import * as Sentry from 'utils/errorTracking';
import { getAPI } from 'utils/helpers';
import apiClient from 'lib/apiClient';

export interface LiveStreamRequestCreated {
  id: string;
  offeringId: string;
  createdDate: string;
}

export interface LiveStreamRequest {
  id: string;
  offeringId: string;
  question: string;
  createdDate: string;
  modifiedDate: string;
}

/**
 * Create a live-stream request for an offering. Auth-required: apiClient
 * injects the Bearer JWT automatically. The backend resolves `offeringId`
 * local-first with a Primary Facade fallback, so either the canonical
 * offering id or the slug is accepted.
 */
export const createLiveStreamRequest = async (
  offeringId: string,
): Promise<LiveStreamRequestCreated> => {
  try {
    const { data } = await apiClient.post<LiveStreamRequestCreated>(
      `${getAPI()}/campaign/livestreams/requests`,
      { offeringId },
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const addQuestionToLiveStreamRequest = async (
  id: string,
  question: string,
): Promise<LiveStreamRequest> => {
  try {
    const { data } = await apiClient.patch<LiveStreamRequest>(
      `${getAPI()}/campaign/livestreams/requests/${id}`,
      { question },
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};
